export default "__VITE_ASSET__0yWBQDIU__"